import { api } from 'app/config/apiConfig';

interface Params {
  depositId: string;
  description?: string;
  refundAmount: number;
}

export const markDepositAsRefundedApi = api.injectEndpoints({
  endpoints: (build) => ({
    markDepositAsRefunded: build.mutation<void, Params>({
      query: (params) => ({
        url: `/billing-documents/deposits/${params.depositId}/mark-refund`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Contracts', 'Contract details', 'Deposit History'],
    }),
  }),
});

export const { useMarkDepositAsRefundedMutation } = markDepositAsRefundedApi;
